export var ServiceDataScope;
(function (ServiceDataScope) {
    /**
     * Execute the provider for each every content element with the defined name.
     *
     * The provided data is stored in {@link CmsContent.serviceData}.
     */
    ServiceDataScope[ServiceDataScope["ELEMENT_ID"] = 0] = "ELEMENT_ID";
    /**
     * Execute the provider once for the first content element with the defined name found on the page.
     *
     * This mode is a combination of the behaviour of {@link GLOBAL_SHARED} but the storage of {@link ELEMENT_ID}.
     *
     * The provided data is stored in {@link CmsContent.serviceData}.
     */
    ServiceDataScope[ServiceDataScope["ELEMENT_NAME"] = 1] = "ELEMENT_NAME";
    /**
     * Execute the provider once for the first content element with the defined name found on the page.
     *
     * The provided data is available in the store (see {@link GlobalState.sharedServiceData}) under the defined key (see {@link ServiceDataProvider.sharedDataKey}).
     */
    ServiceDataScope[ServiceDataScope["GLOBAL_SHARED"] = 2] = "GLOBAL_SHARED";
})(ServiceDataScope || (ServiceDataScope = {}));
export var ProviderExecutionOrder;
(function (ProviderExecutionOrder) {
    /**
     * Providers will be sequentially invoked based on their position in the page.
     *
     * All providers having this order will be invoked before any provider that defined out-of-order execution.
     */
    ProviderExecutionOrder[ProviderExecutionOrder["IN_ELEMENT_ORDER"] = 0] = "IN_ELEMENT_ORDER";
    /**
     * Providers will be invoked in parallel regardless their position in the page.
     *
     * This is the preferred execution order to use for lowest time-to-first-byte.
     */
    ProviderExecutionOrder[ProviderExecutionOrder["OUT_OF_ORDER"] = 1] = "OUT_OF_ORDER";
})(ProviderExecutionOrder || (ProviderExecutionOrder = {}));
//# sourceMappingURL=serviceDataProvider.js.map